import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table, TableBody, TableContainer, TableHead, TableRow, Paper, Container, IconButton
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download, Link as LinkIcon } from "@mui/icons-material";

import { useState, useEffect } from "react";

import Config from "../config.json"; // Pastikan file ini ada
import { dateToStringDate } from "../Helpers"; // Pastikan fungsi ini ada

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function Qcqa() {
  // State untuk bagian Events
  const url_list = Config.api_domain + "/geo/active/";
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [page, setPage] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");

        const data = await res.json();
        setList(data.data || []);
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };

    fetchData();
  }, [url_list]);

  const filteredList = list.filter(item =>
    item.title.toLowerCase().includes(search.toLowerCase())
  );

  const paginatedList = filteredList.slice(
    page * entriesPerPage,
    (page + 1) * entriesPerPage
  );

  function getRows() {
    if (typeof list !== "undefined" && list !== null && list.length > 0) {
      return list.map((row, index) => {
        let dateISO = new Date(row.time_uploaded);
        let formatted_datetime = dateToStringDate(dateISO);
        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>{formatted_datetime}</StyledTableCell>
            <StyledTableCell>
              <IconButton
                aria-label="download"
                component="a"
                href={Config.api_domain + "/geo/download/" + row.public_id}
                download
              >
                <Download />
              </IconButton>
            </StyledTableCell>
          </StyledTableRow>
        );
      });
    } else {
      return (
        <StyledTableRow key="no-data">
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }
  }

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>

        <h2>Policy Expert on Geospatial Data Utilization for Decision Making</h2>

        <h3>Project Description</h3>
        <p style={{ textAlign: "justify" }}>
As part of the Integrated Land Administration and Spatial Planning (ILASP) Project, the
Geospatial Information Agency (BIG) seeks to engage Policy Experts on Geospatial Data
Utilization for Decision Making to support the development of data-driven policy strategies. This
four-month assignment (September–December 2025) aims to enhance the effective use of
geospatial data in government planning and decision-making processes. The expert will provide
analytical insight, strategic guidance, and policy recommendations to support evidence-based
spatial planning, land administration, and climate-related actions. Responsibilities include
identifying policy gaps, promoting cross-sectoral data integration (using data analytic platform
development), and strengthening institutional frameworks for data governance. Acting on behalf
of BIG, the expert will work closely with relevant ministries, technical teams, and stakeholders to
ensure that geospatial data is effectively leveraged in policy formulation, aligned with national
priorities and development goals, and contributes to the overall success of the ILASP Project.

        </p>

        {/* Unduh Section */}
        <h3>Announcement</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getRows()}
            </TableBody>
          </Table>
        </TableContainer>

<h3>Procurement Timeline</h3>
<TableContainer component={Paper} sx={{ mb: 6 }}>
  <Table sx={{ minWidth: 500 }} aria-label="timeline table">
    <TableHead>
      <TableRow>
        <StyledTableCell>No.</StyledTableCell>
        <StyledTableCell>Activity</StyledTableCell>
        <StyledTableCell>Start Date</StyledTableCell>
        <StyledTableCell>End Date</StyledTableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      <StyledTableRow>
        <StyledTableCell>1</StyledTableCell>
        <StyledTableCell>Publication of the REoI and TOR</StyledTableCell>
        <StyledTableCell>7 Aug 2025, 12:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>21 Aug 2025, 16:00 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>2</StyledTableCell>
        <StyledTableCell>Clarifications and Addenda to the REoI and TOR</StyledTableCell>
        <StyledTableCell>11 Aug 2025, 09:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>13 Aug 2025, 12:00 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>3</StyledTableCell>
        <StyledTableCell>Submission of Expressions of Interest (EOI)</StyledTableCell>
        <StyledTableCell>7 Aug 2025, 12:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>21 Aug 2025, 16:00 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>4</StyledTableCell>
        <StyledTableCell>Evaluation of Expressions of Interest (EOI)</StyledTableCell>
        <StyledTableCell>22 Aug 2025, 09:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>23 Aug 2025, 16:00 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>5</StyledTableCell>
        <StyledTableCell>Interview</StyledTableCell>
        <StyledTableCell>25 Aug 2025, 09:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>27 Aug 2025, 16:00 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>6</StyledTableCell>
        <StyledTableCell>Notification of Intention to Award</StyledTableCell>
        <StyledTableCell>28 Aug 2025, 09:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>28 Aug 2025, 16:00 (GMT+7)</StyledTableCell>
      </StyledTableRow>
    </TableBody>
  </Table>
</TableContainer>


        <p style={{ textAlign: "justify" }}>
  <em>Clarifications and Addenda to the REoI and TOR</em> and <em>Submission of Expressions of Interest (EOI)</em> may be submitted via email to:{" "}
  <a href="mailto:pokja.psdmo@big.go.id" style={{ color: "#1976d2", textDecoration: "underline" }}>
    pokja.dapig@big.go.id
  </a>
</p>



      </Container>
    </div>
  );
}

export default Qcqa;
